import PropTypes from 'prop-types';
import React from 'react';

import { IconBike, IconBoot, IconChevronSpriteLarge, IconFlag, IconHeart, IconShoe, IconThumbsUp, IconTrophy, IconWater } from '$partials/icons';

import { useLocale } from '$contexts/locale.jsx';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */


const EMOJI_ICON_MAP = {
    '🚲': IconBike,
    '🥾': IconBoot,
    '🏁': IconFlag,
    '❤️': IconHeart,
    '❤': IconHeart,
    '👟': IconShoe,
    '👍': IconThumbsUp,
    '🏆': IconTrophy,
    '🌊': IconWater,
    '>': IconChevronSpriteLarge
};

// ❤️ must come before ❤ so the two-codepoint variant is matched first
const EMOJI_REGEX = /(🚲|🥾|🏁|❤️|❤|👟|👍|🏆|🌊|>)/u;

const renderTextWithIcons = (text) =>
    text.split(EMOJI_REGEX).map((part, i) => {
        const Icon = EMOJI_ICON_MAP[part];
        if (Icon) {
            return (
                <span
                    className='animated-statement__icon animated-statement__icon--black'
                    key={i}>
                    <span><Icon /></span>
                </span>
            );
        }
        return part || null;
    });

/**
 * @param {{ richText: any, color?: string }} props
 */
const AnimatedText = ({ richText }) => {
    const { formatURI } = useLocale();

    if (!richText?.json?.content) {
        return null;
    }

    return richText.json.content
        .filter((/** @type {any} */ block) => block.content?.length)
        .map((/** @type {any} */ block, /** @type {number} */ i) => (
            <div
                className='animated-statement__lines'
                key={i}>
                {block.content.map((/** @type {any} */ node, /** @type {number} */ j) => {
                    if (node.nodeType === 'hyperlink') {
                        const innerText = node.content?.[0];
                        return (
                            <a
                                className='inline-block'
                                href={formatURI(node.data?.uri)}
                                key={j}>
                                <span className='animated-statement__highlight animated-statement__highlight--orange'>
                                    {innerText?.value}
                                </span>
                                <span className='animated-statement__icon animated-statement__icon--animated animated-statement__icon--orange'>
                                    <span className='button__icon button__icon--animate'>
                                        <IconChevronSpriteLarge />
                                    </span>
                                </span>
                            </a>

                        );
                    }
                    if (node.nodeType === 'text' && node.marks?.some((/** @type {any} */ mark) => mark.type === 'italic')) {
                        const arr = node.value.split(/[,;]\s*/);
                        return (
                            <span
                                className='animated-statement__scroll animated-statement__scroll--black'
                                key={j}>
                                <span className='animation__scroll-up'>
                                    {arr.map((itm, idx) => {
                                        return (<span key={idx}>{itm}</span>);
                                    }).filter(Boolean)}
                                </span>
                            </span>
                        );
                    }
                    if (node.nodeType !== 'text') {
                        return null;
                    }
                    const isBold = node.marks?.some((/** @type {any} */ mark) => mark.type === 'bold');
                    return isBold ? (
                        <span
                            className='animated-statement__highlight animated-statement__highlight--black'
                            key={j}>
                            {renderTextWithIcons(node.value)}
                        </span>
                    ) : (
                        <React.Fragment key={j}>{renderTextWithIcons(node.value)}</React.Fragment>
                    );
                })}
            </div>
        ));
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

const propTypes = {
    richText: PropTypes.object
};

AnimatedText.propTypes = propTypes;

export { AnimatedText };
export default AnimatedText;
